// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"87840115","511":"7fb246ba","918":"f4bb80f8","927":"c6229b26"}[chunkId] + ".css";
};